import * as React from "react"
const IconName = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 20}
        height={props.height || 20}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke || "#414651"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth || 2}
            d="m19 16.121-1 1.094c-.53.58-1.25.906-2 .906a2.71 2.71 0 0 1-2-.906 2.716 2.716 0 0 0-2-.904c-.75 0-1.469.325-2 .904m-9 .906h1.675c.489 0 .733 0 .963-.055a2 2 0 0 0 .579-.24c.201-.123.374-.296.72-.642L17.5 4.621a2.121 2.121 0 1 0-3-3L1.937 14.184c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579c-.055.23-.055.475-.055.964v1.674Z"
        />
    </svg>
)
export default IconName
